module.exports = __webpack_public_path__ + "static/media/orchid.3adec5bd.svg";